import React, { useMemo } from 'react';
import { getStatusOpName, OP_STATUS } from "../../../../../util/varibles/constants";
import { getOperationStatus, stepNameV2 } from "../../../../../util/varibles/global";
import { IOperation2, IService2 } from "../../../../../util/varibles/interface";
import SiteDisease from "../../../../Operation/FishDisease/SiteDisease";
import LiceList from "../../../../Operation/LiceList";
import ActivityLog from "../../_component/AcitivtyLog";
import ApproveControl from "../../_component/ApproveControl";
import Approver from "../../_component/Approver";
import AttachFile from "../../_component/AttachFile";
import BoxOpInfo from "../../_component/BoxOpInfo";
import Duration from "../../_component/Duration";
import Status from "../../_component/Status";
import Header from "../../Header";
import { callEventPopupOpInfo } from '../../PopupOpInfoContext';
import stylesContainer from "../../style.module.scss";
import ServiceInfo from "./ServiceInfo";

interface IProps {
    isEdit: boolean
    isApprove: boolean
    data: IOperation2<IService2>
}

const Service: React.FC<IProps> = (props) => {
    const {
        data,
        isEdit,
        isApprove,
    } = props;
    const { updateNote, changeState } = callEventPopupOpInfo();

    const { operation, activity_log } = data;

    const { current_process, status, files = [], request_tab_id, pauses = [] } = operation;
    const { realStatus, statusText } = useMemo(() => {
        if (status === OP_STATUS.PROCESSING) {
            const realStatus = getOperationStatus(status, pauses);
            if (realStatus === OP_STATUS.PAUSE)
                return { realStatus, statusText: getStatusOpName(realStatus) }
            const { key } = activity_log[current_process] || {};
            return { realStatus: status, statusText: stepNameV2(key) }
        }
        return { realStatus: status, statusText: getStatusOpName(status) };

    }, [activity_log, current_process, pauses, status]);

    return <>
        <Header operation={operation}>
            <div className={stylesContainer.title}>
                <div className='ml-3'>
                    <Status status={realStatus} statusText={statusText} />
                </div>
            </div>
        </Header>

        <div className={stylesContainer.body}>
            <ActivityLog />
            <BoxOpInfo data={data} isEdit={isEdit} handleUpdateNote={updateNote}>
                {request_tab_id && <div className={stylesContainer['container-box']}>
                    <span data-lev='name'>Request ID: </span>
                    <span>{request_tab_id}</span>
                </div>}
                <Duration activity_log={activity_log} />
                <AttachFile files={files} />
                <ApproveControl {...{ isApprove, operation, handleChangeState: changeState }} />
                <Approver operation={operation} />
                <SiteDisease diseases={operation.diseases || []} />
                <LiceList diseases={operation.diseases || []} wrapperClass='mb-[5px]' />
                <ServiceInfo operation={operation} />
            </BoxOpInfo>
        </div>
    </>;
};

export default Service;
